/**
 * @generated SignedSource<<f43adb553eac2dcd80feb596166da97b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutRelayAction_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"checkoutShippingReducer_viewer" | "checkoutTransactionReducer_viewer">;
  readonly " $fragmentType": "checkoutRelayAction_viewer";
};
export type checkoutRelayAction_viewer$key = {
  readonly " $data"?: checkoutRelayAction_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutRelayAction_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutRelayAction_viewer"
};

(node as any).hash = "7d4e4a782eded2abe4c73d40d2c177cf";

export default node;
